export default __webpack_public_path__ + "static/media/PlaylistActive.1cc0ba68.svg";